import React, { Component } from 'react'
import Select from 'react-select'
import { Search } from './icons'

let categories = [
  { label: "Buy", value: 'buy' },
  { label: "Lease", value: 'lease' },
  { label: "Sold", value: 'sold' },
]

let commercialType = [
  { label: "Office", value: 'office' },
  { label: "Warehouse", value: 'warehouse' },
  { label: "Retail", value: 'retail' },
  { label: "Development", value: 'development' },
]

let commercialMinArea = [
  { label: "50 m²", value: 50 },
  { label: "100 m²", value: 100 },
  { label: "150 m²", value: 150 },
  { label: "200 m²", value: 200 },
  { label: "250 m²", value: 250 },
  { label: "300 m²", value: 300 },
  { label: "350 m²", value: 350 },
  { label: "400 m²", value: 400 },
  { label: "450 m²", value: 450 },
  { label: "500 m²", value: 500 },
  { label: "750 m²", value: 750 },
  { label: "1000 m²", value: 1000 },
  { label: "1500 m²", value: 1500 },
  { label: "2000 m²", value: 2000 },
  { label: "3000 m²", value: 3000 },
  { label: "5000 m²", value: 5000 },
  { label: "10000 m²", value: 10000 },
]

let commercialMaxArea = [
  { label: "100 m²", value: 100 },
  { label: "150 m²", value: 150 },
  { label: "200 m²", value: 200 },
  { label: "250 m²", value: 250 },
  { label: "300 m²", value: 300 },
  { label: "350 m²", value: 350 },
  { label: "400 m²", value: 400 },
  { label: "450 m²", value: 450 },
  { label: "500 m²", value: 500 },
  { label: "750 m²", value: 750 },
  { label: "1000 m²", value: 1000 },
  { label: "1500 m²", value: 1500 },
  { label: "2000 m²", value: 2000 },
  { label: "3000 m²", value: 3000 },
  { label: "5000 m²", value: 5000 },
  { label: "10000 m²", value: 10000 },
  { label: "20000 m²", value: 20000 },
]
const rentPriceMin = [
  { label: "$700", value: 700 },
  { label: "$800", value: 800 },
  { label: "$900", value: 900 },
  { label: "$1,000", value: 1000 },
  { label: "$1,200", value: 1200 },
  { label: "$1,400", value: 1400 },
  { label: "$1,600", value: 1600 },
  { label: "$1,800", value: 1800 },
  { label: "$2,000", value: 2000 },
  { label: "$2,500", value: 2500 },
  { label: "$3,000", value: 3000 },
  { label: "$3,500", value: 3500 },
]
const rentPriceMax = [
  { label: "$800", value: 800 },
  { label: "$900", value: 900 },
  { label: "$1,000", value: 1000 },
  { label: "$1,200", value: 1200 },
  { label: "$1,400", value: 1400 },
  { label: "$1,600", value: 1600 },
  { label: "$1,800", value: 1800 },
  { label: "$2,000", value: 2000 },
  { label: "$2,500", value: 2500 },
  { label: "$3,000", value: 3000 },
  { label: "$3,500", value: 3500 },
  { label: "$4,000", value: 4000 },
  { label: "$4,500", value: 4500 },
  { label: "$4,500+", value: 20000 },
]

const priceMin = [
  { label: "$750,000", value: 750000},
  { label: "$1,000,000", value: 1000000},
  { label: "$1,250,000", value: 1250000},
  { label: "$1,500,000", value: 1400000},
  { label: "$1,750,000", value: 1750000},
  { label: "$2,000,000", value: 2000000},
  { label: "$2,250,000", value: 2250000},
  { label: "$2,500,000", value: 2500000},
  { label: "$2,750,000", value: 2750000},
  { label: "$3,000,000", value: 3000000},
  { label: "$3,500,000", value: 3500000},
  { label: "$3,750,000", value: 3750000},
  { label: "$4,000,000", value: 4000000},
  { label: "$4,500,000", value: 4500000},
  { label: "$5,000,000", value: 5000000},
]
const priceMax = [
  { label: "$1,000,000", value: 1000000},
  { label: "$1,250,000", value: 1250000},
  { label: "$1,500,000", value: 1400000},
  { label: "$1,750,000", value: 1750000},
  { label: "$2,000,000", value: 2000000},
  { label: "$2,250,000", value: 2250000},
  { label: "$2,500,000", value: 2500000},
  { label: "$2,750,000", value: 2750000},
  { label: "$3,000,000", value: 3000000},
  { label: "$3,500,000", value: 3500000},
  { label: "$3,750,000", value: 3750000},
  { label: "$4,000,000", value: 4000000},
  { label: "$4,500,000", value: 4500000},
  { label: "$5,000,000", value: 5000000},
  { label: "$6,000,000", value: 6000000},
  { label: "$7,000,000", value: 7000000},
  { label: "$8,000,000", value: 8000000},
  { label: "$9,000,000", value: 9000000},
  { label: "$10,000,000+", value: 50000000},
]

const commercialPriceMin = [
  { label: "$750,000", value: 750000},
  { label: "$1,000,000", value: 1000000},
  { label: "$1,500,000", value: 1500000},
  { label: "$2,000,000", value: 2000000},
  { label: "$2,500,000", value: 2500000},
  { label: "$5,000,000", value: 5000000},
  { label: "$10,000,000", value: 10000000},
  { label: "$15,000,000", value: 15000000},
  { label: "$20,000,000", value: 20000000},
  { label: "$30,000,000", value: 30000000},
]
const commercialPriceMax = [
  { label: "$1,000,000", value: 1000000},
  { label: "$1,500,000", value: 1500000},
  { label: "$2,000,000", value: 2000000},
  { label: "$2,500,000", value: 2500000},
  { label: "$5,000,000", value: 5000000},
  { label: "$10,000,000", value: 10000000},
  { label: "$15,000,000", value: 15000000},
  { label: "$20,000,000", value: 20000000},
  { label: "$30,000,000", value: 30000000},
  { label: "$40,000,000+", value: 100000000},
]

const commercialPricePaMin = [
  { label: "$10,000", value: 10000},
  { label: "$20,000", value: 20000},
  { label: "$30,000", value: 30000},
  { label: "$40,000", value: 40000},
  { label: "$50,000", value: 50000},
  { label: "$75,000", value: 75000},
  { label: "$100,000", value: 100000},
  { label: "$150,000", value: 150000},
  { label: "$300,000", value: 300000},
  { label: "$500,000", value: 500000},
  { label: "$1,000,000", value: 1000000},
]
const commercialPricePaMax = [
  { label: "$20,000", value: 20000},
  { label: "$30,000", value: 30000},
  { label: "$40,000", value: 40000},
  { label: "$50,000", value: 50000},
  { label: "$75,000", value: 75000},
  { label: "$100,000", value: 100000},
  { label: "$150,000", value: 150000},
  { label: "$300,000", value: 300000},
  { label: "$500,000", value: 500000},
  { label: "$1,000,000", value: 1000000},
  { label: "$2,000,000+", value: 5000000},
]

const bed_bath_park = [
  { label: "1+", value: 1},
  { label: "2+", value: 2},
  { label: "3+", value: 3},
  { label: "4+", value: 4},
  { label: "5+", value: 5},
  { label: "6+", value: 6}
]

class SearchFormHome extends Component {

  state = {
    action: `/buy/`,
    searchPlaceholder: `Search`,
    category: { label: "Buy", value: 'buy' },
  }

  componentDidMount() {
    this.updateDimensions()
    window.addEventListener("resize", this.updateDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions)
  }

  componentWillReceiveProps(nextProps) {
    // You don't have to do this check first, but it can help prevent an unneeded render
    if (nextProps.propertyType !== this.props.propertyType) {
      this.setState({
        action: nextProps.propertyType === 'commercial' ? `/${this.state.category.value+'-commercial'}/` : `/${this.state.category.value}/`
      })
    }
  }

  updateDimensions = () => {
    if(window.innerWidth < 900) {
      this.setState({ searchPlaceholder: `Search by suburb` });
    } else {
      this.setState({ searchPlaceholder: `Search by suburb` });
    }
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleActionChange = option => {
    if (option.value === this.props.type) return
    this.setState({
      action: this.props.propertyType === 'commercial' ? option.value+'-commercial' : option.value,
      category: categories.find(el => el.value === option.value),
    })
  }

  handleSelectChange = (option, field) => {
    let state = {}
    switch (field && field.action) {
      case 'select-option':
        state[field.name] = option
        this.setState(state)
        break
      default:
        let { name, value } = option.currentTarget
        state[name] = value
        this.setState(state)
        break
    }
  }

  render() {
    let { price_min, price_max, bedrooms, bathrooms, carparks, category, searchPlaceholder, commercial_type, min_area, max_area, action } = this.state
    let { propertyType } = this.props

    return (
      <section className="search">
        <div className="search__inner">
          <form className="search__form form" action={action}>
            <div className="form__row form__row--search">
              <div className='form__select form__select--category'>
                <Select
                  options={categories}
                  onChange={this.handleActionChange}
                  openMenuOnFocus={true}
                  id="category"
                  name="category"
                  value={category}
                  placeholder='Buy'
                  className="react-select-container"
                  classNamePrefix="react-select"
                  ref={node => this.category = node}
                  menuPortal={provided => ({ ...provided, zIndex: 9999 })}
                  menu={provided => ({ ...provided, zIndex: 9999 })}
                />
              </div>
              <input className="form__input" type="text" name="search" placeholder={searchPlaceholder} onChange={this.handleChange} />
              <button type='submit'>
                <Search color={'#233356'} />
              </button>
            </div>
            { propertyType === 'commercial' &&

              <div className="form__row form__row--dropdowns">
                <div className='form__select form__select--type'>
                  <Select
                    options={commercialType}
                    onChange={this.handleSelectChange}
                    openMenuOnFocus={true}
                    id="commercial_type"
                    name="commercial_type"
                    value={commercial_type}
                    placeholder="Type"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    ref={node => this.commercial_type = node}

                  />
                </div>
                <div className='form__select form__select--max-price'>
                  <Select
                    options={category.value === 'lease' ? commercialPricePaMin : commercialPriceMin}
                    onChange={this.handleSelectChange}
                    openMenuOnFocus={true}
                    id="price_min"
                    name="price_min"
                    value={price_min}
                    placeholder={category.value === 'lease' ? 'Min Price P.A.' : 'Min Price'}
                    className="react-select-container"
                    classNamePrefix="react-select"
                    ref={node => this.min = node}
                  />
                </div>
                <div className='form__select form__select--max-price'>
                  <Select
                    options={category.value === 'lease' ? commercialPricePaMax : commercialPriceMax}
                    onChange={this.handleSelectChange}
                    openMenuOnFocus={true}
                    id="price_max"
                    name="price_max"
                    value={price_max}
                    placeholder={category.value === 'leasing' ? 'Max Price P.A.' : 'Max Price'}
                    className="react-select-container"
                    classNamePrefix="react-select"
                    ref={node => this.max = node}
                  />
                </div>
                <div className='form__select form__select--max-area'>
                  <Select
                    options={commercialMinArea}
                    onChange={this.handleSelectChange}
                    openMenuOnFocus={true}
                    id="min_area"
                    name="min_area"
                    value={min_area}
                    placeholder="Min. Area"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    ref={node => this.min_area = node}
                  />
                </div>
                <div className='form__select form__select--max-area'>
                  <Select
                    options={commercialMaxArea}
                    onChange={this.handleSelectChange}
                    openMenuOnFocus={true}
                    id="max_area"
                    name="max_area"
                    value={max_area}
                    placeholder="Max. Area"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    ref={node => this.max_area = node}
                  />
                </div>
              </div>
            }
            { propertyType !== 'commercial' &&
              <div className="form__row form__row--dropdowns">
                <div className='form__select form__select--min'>
                  <Select
                    options={category.value === 'lease' ? rentPriceMin : priceMin}
                    onChange={this.handleSelectChange}
                    openMenuOnFocus={true}
                    id="price_min"
                    name="price_min"
                    value={price_min}
                    placeholder="Min Price"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    ref={node => this.min = node}

                  />
                </div>
                <div className='form__select form__select--max'>
                  <Select
                    options={category.value === 'lease' ? rentPriceMax : priceMax}
                    onChange={this.handleSelectChange}
                    openMenuOnFocus={true}
                    id="price_max"
                    name="price_max"
                    value={price_max}
                    placeholder="Max Price"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    ref={node => this.max = node}
                  />
                </div>
                <div className='form__select form__select--bed'>
                  <Select
                    options={bed_bath_park}
                    onChange={this.handleSelectChange}
                    openMenuOnFocus={true}
                    id="bedrooms"
                    name="bedrooms"
                    value={bedrooms}
                    placeholder="Bed"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    ref={node => this.bed = node}
                  />
                </div>
                <div className='form__select form__select--bath'>
                  <Select
                    options={bed_bath_park}
                    onChange={this.handleSelectChange}
                    openMenuOnFocus={true}
                    id="bathrooms"
                    name="bathrooms"
                    value={bathrooms}
                    placeholder="Bath"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    ref={node => this.bath = node}
                  />
                </div>
                <div className='form__select form__select--car'>
                  <Select
                    options={bed_bath_park}
                    onChange={this.handleSelectChange}
                    openMenuOnFocus={true}
                    id="carparks"
                    name="carparks"
                    value={carparks}
                    placeholder="Car"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    ref={node => this.car = node}
                  />
                </div>
              </div>
            }
          </form>
        </div>
      </section>
    )
  }
}

export default SearchFormHome
